if (!customElements.get('model-item-swiper')) {
    class ModelItemSwiper extends HTMLElement {
        constructor() {
            super();
            this._swiperContainer = null;
            this._swiperInstance = null;
            this._resizeHandler = this._onResize.bind(this);
        }

        connectedCallback() {
            requestAnimationFrame(() => {
                this._swiperContainer = this.querySelector('.swiper');
                this.initializeSwiper();
                window.addEventListener('resize', this._resizeHandler);
            });
        }

        disconnectedCallback() {
            window.removeEventListener('resize', this._resizeHandler);
        }

        _onResize() {
            if (window.innerWidth > 1440) {
                if (this._swiperInstance) {
                    const newSlidesOffsetBefore = this._calculateSlidesOffsetBefore();
                    this._swiperInstance.params.slidesOffsetBefore = newSlidesOffsetBefore;
                    this._swiperInstance.update();
                }
            }
        }

        _calculateSlidesOffsetBefore() {
            // 获取页面中第一个匹配的 .page-width 元素
            const element = document.querySelector('.page-width');

            if (!element) {
                console.log('没有找到匹配的元素');
                return 0;
            }

            // 获取元素的计算样式
            const computedStyle = getComputedStyle(element);

            // 获取 --page-width 的值
            const pageWidth = computedStyle.getPropertyValue('--page-width').trim();
            const pageWidthValue = parseFloat(pageWidth);
            const pageWidthUnit = pageWidth.match(/[a-zA-Z]+/)[0];

            let pageWidthInPx;
            if (pageWidthUnit === 'rem') {
                const rootFontSize = 10; // 根字体大小，可能需要根据实际情况调整
                pageWidthInPx = pageWidthValue * rootFontSize;
            } else {
                pageWidthInPx = pageWidthValue;
            }

            // 获取 --page-padding 的值
            const pagePadding = computedStyle.getPropertyValue('--page-padding').trim();
            const pagePaddingValue = parseFloat(pagePadding);
            const pagePaddingUnit = pagePadding.match(/[a-zA-Z]+/)[0];

            let pagePaddingInPx;
            if (pagePaddingUnit === 'rem') {
                const rootFontSize = 10; // 根字体大小，可能需要根据实际情况调整
                pagePaddingInPx = pagePaddingValue * rootFontSize;
            } else {
                pagePaddingInPx = pagePaddingValue;
            }

            // 计算滑动前的偏移量
            const slidesOffsetBefore = (window.innerWidth - pageWidthInPx - pagePaddingInPx) / 2;

            return slidesOffsetBefore;
        }

        initializeSwiper() {
            if (!this._swiperContainer) {
                console.error('Swiper container not found');
                return;
            }

            const nextButton = this._swiperContainer.querySelector('.swiper-button-next');
            const prevButton = this._swiperContainer.querySelector('.swiper-button-prev');
            const slidesOffsetBefore = this._calculateSlidesOffsetBefore();

            this._swiperInstance = new Swiper(this._swiperContainer, {
                slidesPerGroup: 1,
                slidesPerView: 6.8,
                spaceBetween: 35,
                loop: false,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    },
                    1024: {
                        spaceBetween: 35,
                        slidesPerView: 5,
                    },
                    1280: {
                        slidesPerView: 6,
                    },
                    1401: {
                        slidesOffsetBefore: slidesOffsetBefore,
                        slidesOffsetAfter: slidesOffsetBefore,
                        slidesPerView: 6.8,
                    },
                }
            });
        }
    }

    customElements.define('model-item-swiper', ModelItemSwiper);
}

class ModelItemSwitch extends HTMLElement {
    constructor() {
        super();
        this._swiperContainer = null;
        this._typeSwiperContainer = null;
        this._swiperInstance = null;
        this._typeSwiperInstance = null;
        this._resizeHandler = this._onResize.bind(this);
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this._swiperContainer = this.querySelector('.model-switch-swiper');
            this._typeSwiperContainer = this.querySelector('.model-has_switch-swiper');
            this.initializeSwitchSwiper();
            this.initializeTypeSwiper();
            window.addEventListener('resize', this._resizeHandler);
        });
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this._resizeHandler);
    }

    _onResize() {
        if (this._swiperInstance) {
            this._swiperInstance.update();
        }
        if (this._typeSwiperInstance) {
            this._typeSwiperInstance.update();
        }
    }

    initializeSwitchSwiper() {
        if (!this._swiperContainer) {
            console.error('Swiper container not found');
            return;
        }
        // const num = this ? parseInt(this.getAttribute('data-num'), 10) : 1;
        // console.log(num);
        this._swiperInstance = new Swiper(this._swiperContainer, {
            slidesPerGroup: 1,
            centerInsufficientSlides: true,
            // spaceBetween: 100,
            slidesPerView: 'auto',
            // width: undefined,
            // slidesPerView: num,
            loop: false,
            watchSlidesVisibility: true,
            breakpoints: {
                320: {
                    // spaceBetween: 35,
                    // centerInsufficientSlides: true,
                },
                768: {
                    // spaceBetween: 100,
                    // centerInsufficientSlides: true,
                },
            },
            // on: {
            //     init: (swiper) => {
            //         console.log(swiper.getTranslate());
            //     },
            // },
        });
    }
    initializeTypeSwiper() {
        if (!this._typeSwiperContainer) {
            console.error('TypeSwiper container not found');
            return;
        }


        this._typeSwiperInstance = new Swiper(this._typeSwiperContainer, {
            slidesPerGroup: 1,
            slidesPerView: 1,
            allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            thumbs: {
                swiper: this._swiperInstance,
            }
        });
    }
}
customElements.define('model-item-swiper-switch', ModelItemSwitch);